module.exports = __webpack_public_path__ + "img/picto-EV 2 blue.16f87de2.svg";